import { createContext } from 'react';

import { THEME_NAME } from '@/constants/theme';

export const ThemeContext = createContext({ name: THEME_NAME.LIGHT });

ThemeContext.displayName = 'ThemeContext';
